<template>
  <div class="person-list-item-birthday">
    <div class="row person">
      <div class="col-3 col-sm-4 col-md-3">
        <span class="d-flex flex-column align-items-center">
          <div class="thumbnail d-flex justify-content-center align-items-center">
            <icon name="child" style="color: #bcc6d3;"></icon>
          </div>
        </span>
      </div>
      <div class="col-9 col-sm-8 col-md-9">
        <span class="d-none d-sm-block" style="margin-top: 5px"></span>
        <h3>{{ person.full_name }}</h3>
        <p>Jarig op {{ dayOfWeek }} {{ dateOfBirth }} (wordt {{ person.age }} jaar)</p>
        <p v-if="subtitle">{{ subtitle }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/Icon'
export default {
  name: 'person-list-item-birthday',
  props: ['person', 'subtitle'],
  components: {
    Icon
  },
  computed: {
    dayOfWeek () {
      return this.$moment(this.person.date).format('ddd')
    },
    dateOfBirth () {
      return this.$moment(this.person.date_of_birth).format('D MMM')
    }
  }
}
</script>

<style scoped>
  h3, p {
    margin: 0;
    color: #666;
  }
  .person {
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .thumbnail {
    width: 66px;
    height: 66px;
    border-radius: 50%;
    border: 3px solid #dedee7;
    background-color: white;
  }
</style>
